import { InjectionToken } from '@angular/core';
import { TNumberPerSize } from '@df/core/df-core.interfaces';
import { IListingSizeOption } from './listing/size/listing-size';
import { IListingSortOption } from './listing/sort/listing-sort';
import { IRelatedProductsOptions } from './related-products/related-products.service';

export namespace NCatalogUi {
    export const DEFAULT_OPTIONS = <NCatalogUi.IModuleOptions>{
        listing: {
            filters: {
                useGroups: false
            },
            /**
             * reset scroll top on listing changes
             * numeric = pixesl value
             * array = value per size
             * undefined = no scroll
             */
            resetTop: 100,
            category: {
                infScrollInit: [6, 12, 12, 12],
                infScrollStep: [6, 12, 12, 12]
            },
            cms: {
                infScrollInit: [6, 12, 12, 12],
                infScrollStep: [6, 12, 12, 12]
            }
        },
        relatedProducts: {
            defaultConfig: {
                engines: ['category'],
                normalize: true,
                disalowDiscounted: false
            }
        },
        pdp: {
            configurable: {
                respectStockSettings: false
            }
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_CATALOG_UI_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        listing: {
            filters: {
                useGroups: boolean;
            };
            /**
             * reset scroll top on listing changes
             * numeric = pixesl value
             * array = value per size
             * undefined = no scroll
             */
            resetTop: number | number[] | false;
            category: {
                infScrollStep?: number | number[];
                infScrollInit?: number | number[];
                sort?: IListingSortOption[];
                size?: IListingSizeOption[];
                defaultSize?: TNumberPerSize;
                addToStructuralData?: boolean;
            };
            cms: {
                infScrollStep?: number | number[];
                infScrollInit?: number | number[];
                sort?: IListingSortOption[];
            };
        };

        relatedProducts: {
            defaultConfig: IRelatedProductsOptions;
        };

        pdp: {
            configurable: {
                /**
                 * When true configurable options on PDP
                 * will be visible or hidden respecting
                 * website stock visibility setting
                 * comming in app.data.showOutOfStock
                 */
                respectStockSettings: boolean;
            };
        };
    }
}
